(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nz-ugc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nz-ugc')) {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    class NzUgc extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-nz-ugc-list]');
        this.videos = [...this.querySelectorAll('video[data-src]')];
        // Load a video when it comes near the screen, play it while it is visible
        this.observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              const video = entry.target;
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                if (!video.src) video.src = video.dataset.src;
                if (!reduced.matches) video.play().catch(() => {});
              } else {
                video.pause();
              }
            }
          },
          { threshold: [0, 0.5] }
        );
        for (const video of this.videos) {
          this.observer.observe(video);
          // A tap plays or pauses (and plays at all with reduced motion)
          video.addEventListener('click', () => {
            if (!video.src) video.src = video.dataset.src;
            if (video.paused) video.play().catch(() => {});
            else video.pause();
          });
        }
        this.arrows = [...this.querySelectorAll('.nz-ugc__arrow')];
        for (const arrow of this.arrows) {
          arrow.addEventListener('click', () => {
            const card = this.list.querySelector('.nz-ugc__item');
            const step = card ? card.getBoundingClientRect().width + 12 : this.list.clientWidth;
            this.list.scrollBy({ left: step * 2 * Number(arrow.dataset.dir), behavior: 'smooth' });
          });
        }
        this.onScroll = () => this.updateArrows();
        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateArrows();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.list?.removeEventListener('scroll', this.onScroll);
      }

      updateArrows() {
        const max = this.list.scrollWidth - this.list.clientWidth - 2;
        this.arrows[0].disabled = this.list.scrollLeft <= 2;
        this.arrows[1].disabled = this.list.scrollLeft >= max;
      }
    }

    customElements.define('nz-ugc', NzUgc);
  }

  } catch(e) { console.error(e); }
})();
})();
